// extracted by mini-css-extract-plugin
module.exports = {"mapContainer":"BoundingBoxMap_mapContainer__1Y7WK","map":"BoundingBoxMap_map__1tJTl","title":"BoundingBoxMap_title__1BGGk"};